<template>
    <div class="fill-height of-y d-flex align-center mr-2" >
        <div class="ml-4 text-h5 font-weight-light">
            Users
        </div>
        <div class="flex-grow-1">
            <slot></slot>
        </div>

        <v-btn
                color="primary"
                class="mx-2"
                small
                @click="$store.state.ref.users.showAdd = true"
                outlined
        >
            <v-icon small left>mdi-plus</v-icon>
            Add User
        </v-btn>

        <div style="width: 300px">
            <v-text-field
                    placeholder="Search"
                    hide-details
                    class="pa-0 ma-0 mx-2"
                    color="primary"
                    prepend-inner-icon="mdi-magnify"
                    solo
                    dense
                    v-model="$store.state.ref.users.filterStr"
            ></v-text-field>
        </div>
<!--        <v-btn-->
<!--                icon-->
<!--                color="primary"-->
<!--                class="mx-2"-->
<!--                small-->
<!--        >-->
<!--            <v-icon>mdi-microsoft-excel</v-icon>-->
<!--        </v-btn>-->
    </div>
</template>

<script>
export default {
    components: {

    },
    props: {
        shown: Boolean
    },
    data() {
        return {

        }
    },
    watch: {

    },
    methods: {

    },
    computed: {

    },
}
</script>

<style scoped>

</style>